import {IBaseLookup} from "./Ibase.lookup";

export namespace ExamSearchCriteria {

	export const lookupName: string = "ExamSearchCriteria";

	export interface ExamSearchCriteria {
		examSearchCriteriaKey: number;
		code: string;
		description: string;
		criteriaOrder: number;
		worklistColumn: string;
		inputType: string;
		active: string;
		lastUpdated: Date;
	}

	export interface ExamSearchCriteriaDS extends IBaseLookup {
		examSearchCriteria: ExamSearchCriteria[];
	}
}
